import { WithRef } from '../../../types';
import IconBase, { IconProps } from '../IconBase';

const renderFill = (color?: string, borderColor?: string) => (
  <>
    <rect x="5" y="5" width="22" height="22" rx="2" fill={color} />
    {borderColor && (
      <rect
        x="5"
        y="5"
        width="22"
        height="22"
        rx="2"
        strokeWidth="2"
        fill="none"
        stroke={borderColor}
      />
    )}
    <rect
      x="11.5"
      y="11.5"
      width="9"
      height="9"
      rx="2"
      strokeWidth="2"
      fill="none"
      stroke="white"
    />
  </>
);

const renderRegular = (color: string, borderColor?: string) => (
  <>
    <rect
      x="5"
      y="5"
      width="22"
      height="22"
      rx="2"
      fill="none"
      strokeWidth="2"
      stroke={borderColor ?? color}
    />
    <rect
      x="11.5"
      y="11.5"
      width="9"
      height="9"
      rx="2"
      strokeWidth="2"
      fill="none"
      stroke={color}
    />
  </>
);

type CastNodeProps = {
  borderColor?: string;
} & IconProps;
export const CastNode = ({
  ref,
  borderColor,
  color = 'currentColor',
  ...props
}: WithRef<SVGSVGElement, CastNodeProps>) => {
  return (
    <IconBase ref={ref} color={color} {...props}>
      {props.weight === 'fill'
        ? renderFill(color, borderColor)
        : renderRegular(color, borderColor)}
    </IconBase>
  );
};

CastNode.displayName = 'CastNode';
